export default "__VITE_ASSET__DAzv2bEk__"